import { useState, useCallback } from "react";

// validates and parses stored ids, rejects corrupted data
const readIds = (key) => {
  try {
    const raw = localStorage.getItem(key);
    const arr = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(arr) ? arr.filter((id) => typeof id === "string") : []);
  } catch {
    return new Set();
  }
};

export function useSavedIds(key = "vrtta_saved_listings") {
  const [ids, setIds] = useState(() => readIds(key));

  const toggle = useCallback(
    (id) => {
      setIds((prev) => {
        const next = new Set(prev);
        next.has(id) ? next.delete(id) : next.add(id);
        localStorage.setItem(key, JSON.stringify([...next]));
        return next;
      });
    },
    [key]
  );

  return { ids, toggle, count: ids.size };
}
